import { ContentStoreTaxonomiesService } from 'src/services/Taxonomies';

export const deleteTaxonomy = (
    { accessToken, id }: App.Taxonomy.DeleteMutationVariables,
): Promise<void> => ContentStoreTaxonomiesService.deleteTaxonomy(accessToken, id);
